import { Insights } from "../Insights"

export class EventBase {
    static log<P extends object>(name: string, params: P) {
        Insights.logEvent(name, params)
    }
}
